<template>
  <div class="card-form">
    <page-main
        :tableData="tableData"
        :loading="loading"
        :tablePage="page"
        @reload="reload"
        @openEditPage="openEditPage"
    >
      <page-header
          ref="header"
          slot="header"
          @query="getData"
          @reset="resetPage"
      >
        <template>
          <el-badge
              :value="checkedRowCount"
              :hidden="!checkedRowCount"
              class="clearable-button"
              :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                @click="exportFile()"
            >
              {{ $l('btn_detail_export') || '导出订单明细' }}
              <i class="el-icon-circle-close" />
            </b-button>
          </el-badge>
        </template>
      </page-header>
      <pagination
          size="small"
          align="right"
          slot="pager"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
      />
    </page-main>
    <chooseTemplate
        :visible.sync="chooseTemplateOptions.visible"
        :templateQueryParams="{ templateGroup: 'shipment-jd-order-detail' }"
        :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import chooseTemplate from '@/views/ecom/components/choose-template'

export default {
  mixins: [BaseTable, EditLoading],
  components: {PageHeader, PageMain, chooseTemplate},
  data() {
    return {
      usePage: true,
      checkedRows: [],
      currSearchForm: {},
      chooseTemplateOptions: {visible: false},
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
      .ecomHxShipmentJdOrderPageListApi({...form, ...this.page})
      .then((res) => {
        this.loading = false
        this.setData(res)
        this.currSearchForm = form
      })
      .catch(() => {
        this.loading = false
      })
    },
    openEditPage({pageType, params = {}, query = {}}) {
      this.$router.push({
        name: 'ecom-hxBiz-jdOrder-detail',
        params: {...params, pageType},
        query,
      })
    },
    exportFile() {
      if (!this.tableData || !this.tableData.length) {
        this.$message({
          message:
              this.$l('tips_exportEmptyData') ||
              '当前条件无匹配库存数据，请修改查询后重试！',
          type: 'warning',
        })
        return
      }

      const searchForm = {
        ...this.currSearchForm,
        sortFields: this.sortFields,
      }

      this.chooseTemplateOptions = {visible: true, searchForm}
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}

.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }

  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
